export default class UIStrings {
    static readonly CompanyIsAFairRecruiter = (companyName: string) => `${companyName} is a fair recruiter`;
    static readonly AllCandidatesCanApplyRegardlessOfJobExperience =
        'All candidates can apply regardless of job experience and educational background';
    static readonly AllCandidatesWillBeGivenAUniqueChance =
        'All candidates will be given a fair chance to showcase their unique skills and talent, by completing the following suite of talent assessment tests:';
    static readonly Minutes = 'minutes';
    static readonly ApplyNow = 'Apply Now';

    static readonly GraduateOrAnalyst = 'Graduate / Analyst';
    static readonly Associate = 'Associate';
    static readonly Manager = 'Manager';
    static readonly Director = 'Director';
    static readonly CLevelOrManagingDirector = 'VP / C-level / Managing Director';
    static readonly JobDetails = 'Job details';
    static readonly SkillsThatMakeYouSucceedInThisRole = 'Skills that make you succeed in this role';
    static readonly HardSkills = 'Hard skills';
    static readonly SoftSkillsAndPersonality = 'Soft skills and personality';

    static readonly PoweredBy = 'Powered by';
    static readonly TalentMesh = 'TalentMesh';

    static readonly Remote = 'Remote';
    static readonly OnLocation = 'On-location';
    static readonly Hybrid = 'Hybrid';

    static readonly FullTime = 'Full-time';
    static readonly Permanent = 'Permanent';
    static readonly Contract = 'Contract';
    static readonly PartTime = 'Part-time';
    static readonly Temporary = 'Temporary';
    static readonly Internship = 'Internship';
    static readonly Yearly = 'Yearly';

    static readonly Skills = 'Skills';
    static readonly Aptitude = 'Aptitude';
    static readonly Personality = 'Personality';
    static readonly EmotionalIntelligence = 'Emotional Intelligence';

    static readonly CompleteTalentAssessmentTests = (tests: number) =>
        `Complete ${tests} talent assessment test${tests > 1 ? 's' : ''}`;

    static readonly ShareThisJob = 'Share this job';
    static readonly ShareThisJobOnSocialOrCopyLink = 'Share this job on social media or copy the job link.';
    static readonly CopyLink = 'Copy link';

    static readonly LinkHasBeenCopied = 'Link has been copied!';
}
